import { clients } from '@/services/client.factory'

const route = {
    namespaced: true,
    state: {
        item: null,
        items: [],
        error: null,
        errors: {},
    },
    getters: {
        item: (state) => state.item,
        items: (state) => state.items,
        error: (state) => state.error,
        errors: (state) => state.errors,
    },
    mutations: {
        ROUTE_SET_ITEM(state, item) {
            Object.assign(state, { item })
        },
        ROUTE_UPDATE_ITEM(state, item) {
            state.item = Object.assign({}, state.item, item)
        },
        ROUTE_SET_ITEMS(state, items) {
            Object.assign(state, { items })
        },
        ROUTE_SET_ERROR(state, error) {
            Object.assign(state, { error })
        },
        ROUTE_SET_ERRORS(state, errors) {
            Object.assign(state, { errors })
        },
    },
    actions: {
        getItem(context, id) {
        },
        async getItems({ commit }, categoryId) {
            await clients.placeServiceClient.getRoutes(categoryId)
                .then((res) => res.data)
                .then((data) =>
                    commit('ROUTE_SET_ITEMS', data)
                )
        },
        create(context) {
        },
        update(context) {
        },
        remove(context, item) {
        }
    }
}

export default route;